import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { ComponentSharedModule } from '@components/component.shared.module';
import { UiParameterCollectionComponent } from '@components/shared/ui-parameter-collection/ui-parameter-collection.component';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { MatTooltipModule } from '@directives/ui-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        CommonModule,
        ComponentSharedModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        UiGridModule,
        UiToggleSwitchModule,
        MatInputModule,
        MatTooltipModule,
        TranslateModule,
        UiNgLetModule,
        UiAutofocusModule,
    ],
    declarations: [
        UiParameterCollectionComponent,
    ],
    exports: [
        UiParameterCollectionComponent,
    ],
})
export class UiParameterCollectionModule { }
